import React from "react";
import { useTranslation } from "react-i18next";
import { createBrowserRouter, Navigate, useParams } from "react-router-dom";

import { MultiLanguageUrl } from "../constants/multiLanguage.constant";
import ErrorPage from "../pages/site/ErrorPage";
import AuthRouter from "./auth.router";
import DashboardRouter from "./dashboard.router";
import PartnerAuthRouter from "./partnerAuth.router";
import SiteRouter from "./site.router";

const ChatRedirect = () => {
  const { i18n } = useTranslation();
  const { code } = useParams();
  const encodeURICode = encodeURIComponent(code as string);
  return (
    <Navigate
      to={`/${
        MultiLanguageUrl[i18n.language] || "en-US"
      }/chat/${encodeURICode}`}
      replace
    />
  );
};

const router = createBrowserRouter([
  ...SiteRouter,
  ...AuthRouter,
  ...PartnerAuthRouter,
  ...DashboardRouter,
  {
    path: "",
    element: <Navigate to={"/en-US"} />,
    errorElement: <ErrorPage />
  },
  {
    path: "/",
    element: <Navigate to={"/en-US"} />,
    errorElement: <ErrorPage />
  },

  {
    path: "/home",
    element: <Navigate to={"/en-US"} />,
    errorElement: <ErrorPage />
  },
  {
    path: "/home/en-US",
    element: <Navigate to={"/en-US"} />,
    errorElement: <ErrorPage />
  },
  {
    path: "/home/fr-FR",
    element: <Navigate to={"/fr-FR"} />,
    errorElement: <ErrorPage />
  },
  {
    path: "/chat/:code",
    element: <ChatRedirect />,
    errorElement: <ErrorPage />
  }
]);

export default router;
